import { CreatePasswordModel } from './../../shared/user.model';
import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
//import { UserService } from '../../shared/user.service';
import { RegistrationService } from '../../registration.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../shared/ErrorHandler';
import swal from 'sweetalert2';

@Component({
  selector: 'app-create-password',
  templateUrl: './create-password.component.html',
  styleUrls: ['./create-password.component.css']
})
export class CreatePasswordComponent implements OnInit {
  UserId: string;
  
  formSubmitted: boolean;
  title="Add New Password";
  user:CreatePasswordModel;
  IsServiceHavingPhone: any;
  constructor(private errorHandler:ErrorHandler,private route: ActivatedRoute,private userService: RegistrationService) {
    this.formSubmitted = false;   
    this.user=new CreatePasswordModel;
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      
      this.UserId = params['UserId']; 
      this.IsServiceHavingPhone= params['IsServiceHavingPhone'];
    });
  }
  onSubmit(form:NgForm){    
    if (!form.invalid) 
    {              
      debugger;
      this.user.UserId = this.UserId;
      document.getElementById('loader-spinner').style.display = "block";
      this.userService.ResetPassword(this.user).subscribe(
      (data:any) => {
        debugger;
        document.getElementById('loader-spinner').style.display = "none";
        swal('','Password changed successfully!','success');
        //this.router.navigate(['/home/accounthead']);        
      }, (error) => {
        document.getElementById('loader-spinner').style.display="none";
        this.errorHandler.HandlerError(error);
      });       
    }
    else
    {
      this.formSubmitted = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/registration/create-password/create-password.component.ts